module.exports = __webpack_public_path__ + "static/media/DinersClub.cb1e4f80.svg";